// extracted by mini-css-extract-plugin
module.exports = {"punchout":"Tailwind-styles-module--punchout--3Gq2j"};